import { Modal } from '../common/modal';
import SessionExpiredModalTemplate from './SessionExpiredModal.html';
const { text } = window;

export default class SessionExpiredModal extends Modal {
    constructor(forwardUrl) {
        const supportUrl =
            window.OverDrive.librarySupportUrl !== ''
                ? window.OverDrive.librarySupportUrl
                : window.routes.supportMembers;
        const signInUrl = `${window.routes.accountInvalidCard}${
            forwardUrl ? `?forward=${encodeURIComponent(forwardUrl)}` : ''
        }`;

        const supportText = text('reauthenticateModal.supportText', {
            link: supportUrl,
        });
        const modalContents = {
            classes: ['SessionExpiredModal'],
            title: text('reauthenticateModal.heading'),
            content: SessionExpiredModalTemplate({
                signInUrl,
                supportText,
            }),
        };

        super(modalContents);
        this.$el.find('.cancel').on('click', () => {
            this.close();
        });
    }
}
